import { useState } from 'react';

const COOKIE = 'os_nav_expanded';
const ONE_YEAR = 60 * 60 * 24 * 365;

function readCookie(): boolean {
  return document.cookie.split('; ').includes(`${COOKIE}=true`);
}

export function useRailState(): [boolean, () => void] {
  const [isExpanded, setIsExpanded] = useState(readCookie);

  const toggle = () => {
    const next = !isExpanded;

    document.cookie = `${COOKIE}=${next}; path=/; max-age=${ONE_YEAR}; samesite=lax`;
    document.body.dataset.osNav = next ? 'expanded' : 'collapsed';
    setIsExpanded(next);
  };

  return [isExpanded, toggle];
}
